import React, { useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import {
    Card,
    CardContent,
    Typography,
    Box,
    Divider,
    Grid,
    Chip,
} from "@mui/material";
import FlightSegment from "./MultiFlightSegment";
import { useLocation } from "react-router-dom";

const getTripLabel = (tripIndicator, idx) => {
    if (tripIndicator === 1) return "First Flight";
    if (tripIndicator === 2) return "Second Flight";
    return `Leg ${idx + 1}`;
};

const FlightCard = ({ flight, searchDetails, resultIndex, traceId }) => {
    const location = useLocation();

    const { flightsData } = location.state || {};
    console.log("traceid", flightsData?.Response?.TraceId);



    const fetchFareQuoteAndSSR = async (traceId, resultIndex) => {
        try {
            const fareQuoteUrl = "https://api.ipaisa.co.in/myapp/flight/farequote";
            const jwtToken = sessionStorage.getItem("jwtToken"); // Adjust as needed

            const fareQuotePayload = {
                traceId,
                resultIndex,
            };

            const fareQuoteResponse = await axios.post(fareQuoteUrl, fareQuotePayload, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            });

            const fareData = fareQuoteResponse?.data?.data;
            const errorMessage =
                fareData?.Response?.Error?.ErrorMessage ||
                "Something went wrong while fetching fare details.";
            toast.error(errorMessage);

            const isLcc = fareData?.Response?.Results?.IsLCC;

            if (isLcc) {
                const ssrUrl = "https://api.ipaisa.co.in/myapp/flight/ssr";
                const ssrPayload = { traceId, resultIndex };

                try {
                    const ssrResponse = await axios.post(ssrUrl, ssrPayload, {
                        headers: {
                            Authorization: `Bearer ${jwtToken}`,
                            "Content-Type": "application/json",
                        },
                    });

                    const ssrData = ssrResponse?.data?.Response;

                    if (ssrData?.Error?.ErrorCode === 27) {
                        console.warn("No SSR details found. Proceeding to booking.");
                        // render book button here
                    } else if (ssrData?.Error?.ErrorCode !== 0) {
                        toast.error(
                            ssrData?.Error?.ErrorMessage || "SSR fetch failed. Please try again."
                        );
                        return;
                    } else {
                        console.log("SSR Data:", ssrData);
                        // Handle SSR data normally (render seat options, meals, etc.)
                    }
                } catch (error) {
                    console.error("SSR API Error:", error);
                    toast.error("Unable to fetch SSR. Please try again later.");
                    return;
                }
            } else {
                console.log("isLcc is false, skipping SSR.");
                // render book button directly
            }

        } catch (error) {
            const errorMessage =
                error?.response?.data?.data?.Response?.Error?.ErrorMessage ||
                error?.message ||
                "Something went wrong while fetching data.";
            toast.error(errorMessage);
        }
    };
    const handleCardClick = () => {
        console.log("Clicked Flight Details:", flight);
        const clickindex = flight.ResultIndex // Default to 0 if ResultIndex is not available
        console.log("clicked resultindex", flight.ResultIndex);
        console.log("clicked traceId", traceId);
        if (traceId && resultIndex !== undefined && resultIndex !== null) {
            fetchFareQuoteAndSSR(traceId, clickindex);
        }
    };


    const fare = flight.FareBreakdown?.[0]?.RootFareTotal || 0;

    return (
        <Card
            sx={{ mb: 4, borderRadius: 3, boxShadow: 3, cursor: "pointer" }}
            onClick={handleCardClick}
        >


            <CardContent>
                <Grid container justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h6" component="div">
                        Flight Option
                    </Typography>
                    <Typography variant="h6" color="primary">
                        ₹{fare.toLocaleString()}
                    </Typography>
                </Grid>

                <Box>
                    {flight.Segments.map((segmentGroup, idx) => (
                        <Box
                            key={idx}
                            sx={{
                                border: "1px solid #e0e0e0",
                                borderRadius: 2,
                                p: 2,
                                mb: 2,
                                backgroundColor: "#f9f9f9",
                            }}
                        >
                            <Chip
                                label={getTripLabel(segmentGroup[0]?.TripIndicator, idx)}
                                size="small"
                                color="info"
                                sx={{ mb: 1 }}
                            />
                            <Divider sx={{ mb: 2 }} />
                            {segmentGroup.map((segment, index) => (
                                <FlightSegment key={index} segment={segment} searchDetails={searchDetails} resultIndex={resultIndex}
                                />
                            ))}
                        </Box>
                    ))}
                </Box>

                <Divider sx={{ mt: 2, mb: 1 }} />
                <Typography variant="body2" color="text.secondary">
                    Refundable: <strong>{flight.IsRefundable ? "Yes" : "No"}</strong>
                </Typography>
            </CardContent>
        </Card>
    );
};

export default FlightCard;
